/**
 * RequireAuth — gates a route on a signed-in (server-verified) identity.
 *
 * While the initial getMe check runs we show a spinner. If there is no user
 * (cloud, pre-sign-in → getMe 401), redirect to /login, preserving the intended
 * destination. In local/demo mode getMe always yields a user, so this is a
 * pass-through.
 */

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Loading } from "./Loading";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loading label="Verificando sesión…" />;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
